document.addEventListener("click", function (e) {
    if (e.target.classList.contains("js-activateTab")) {
        e.preventDefault();

        var activateSelector = e.target.getAttribute("href");
        var activate = document.querySelector(activateSelector);
        var tabs = e.target.closest(".c-tabs");

        var currentActiveElements = tabs.querySelectorAll(".is-active");
        currentActiveElements.forEach(function (activeElement) {
            activeElement.classList.remove("is-active");
        });

        e.target.classList.add("is-active");
        activate.classList.add("is-active");
    }
});
